import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as actions from '@appStore/customers/actions';
import { CustomerAccessRequestsActionTypes } from '@appStore/customers/actions/customer-access-requests.actions';
import { CustomerService } from '@appStore/customers/services';
import { AccessRequest } from 'app/models/access-request.model';

@Injectable()
export class CustomerAccessRequestsEffects {
    constructor(private actions$: Actions, private customerService: CustomerService) {}

    accessRequestRequiredLoad$ = createEffect(() => {
        return  this.actions$.pipe(
            ofType(actions.CustomerAccessRequestsActionTypes.AccessRequestRequiredLoad),
            map((action: actions.AccessRequestRequiredLoad) => action.payload),
            exhaustMap(payload => {
               return this.customerService.isAccessRequestRequired(payload).pipe(
                    map(result => new actions.AccessRequestRequiredLoadSuccess(result)),
                    catchError(error => of(new actions.AccessRequestRequiredLoadFail(error)))
                );
            })
        );
    });

    addAccessRequest$ = createEffect(() => {
        return  this.actions$.pipe(
            ofType(CustomerAccessRequestsActionTypes.AddAccessRequest),
            map((action: actions.AddAccessRequest) => action.payload),
            exhaustMap(payload => {
               return this.customerService.addAccessRequest(payload).pipe(
                    map(result => new actions.AddAccessRequestSuccess(result)),
                    catchError(error => of(new actions.AddAccessRequestFail(error)))
                );
            })
        );
    });

    getCustomerAccessRequests$ = createEffect(() => {
        return  this.actions$.pipe(
            ofType(CustomerAccessRequestsActionTypes.CustomerAccessRequestsLoad),
            exhaustMap(() => {
               return this.customerService.getMyCustomersAccessRequests().pipe(
                    map((result: AccessRequest[]) => new actions.CustomerAccessRequestsLoadSuccess(result)),
                    catchError(error => of(new actions.CustomerAccessRequestsLoadFail(error)))
                );
            })
        );
    });

    changeAccessRequestState$ = createEffect(() => {
        return  this.actions$.pipe(
            ofType(CustomerAccessRequestsActionTypes.ChangeAccessRequestState),
            map((action: actions.ChangeAccessRequestState) => action.payload),
            exhaustMap(payload => {
               return this.customerService.changeAccessRequestState(payload.accessRequestId, payload.newState).pipe(
                    map((result: AccessRequest) => new actions.ChangeAccessRequestStateSuccess(result)),
                    catchError(error => of(new actions.ChangeAccessRequestStateFail(error)))
                );
            })
        );
    });
}